export const SearchingActionTypes = {
    SEARCH_USER: 'SEARCH_USER',
    ADD_BUTTON: "ADD_BUTTON"
};